// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('select_board');

// eslint-disable-next-line @trello/no-module-logic
export const SelectBoardTemplate = t.renderable(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ name, id, closed, orgName }: any) =>
    t.li('.item', () =>
      t.a(
        '.name.js-select-board',
        { href: '#', title: name, 'data-id': id },
        function () {
          t.span('.item-name', function () {
            t.text(name);
            if (closed) {
              t.text(' ');
              return t.span('.quiet', () => t.format('archived'));
            }
          });
          if (orgName) {
            return t.span('.sub-name', () =>
              t.format('in-orgname', { orgName }),
            );
          }
        },
      ),
    ),
);
